import SendMeResultsModal from './SendMeResultsModal';

export default SendMeResultsModal;
